import { render, staticRenderFns } from "./DlvPSJ.vue?vue&type=template&id=f19d2f50"
import script from "./DlvPSJ.vue?vue&type=script&lang=js"
export * from "./DlvPSJ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports